// Stores persistend local preferences. This is *not* a user profile replacement.

const state = {
  // login name of tenant that tenant login was successfully used with last
  loginTenant: '',
}

const getters = {
  loginTenant: state => state.loginTenant,
}

const actions = {}

const mutations = {
  saveLoginTenant (state, {loginTenant}) {
    state.loginTenant = loginTenant
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
